import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class FilterItem extends Component {

    constructor(props) {
        super(props)
        this.onClick = this.onClick.bind(this)
    }

    render() {
        const { t } = this.props;
        //TODO: Move to state
        const itemId = this.props.id
        const itemTitle = t(itemId) 
        if (this.props.selected) {
            return <button className="dropdown-item selected" style={{paddingLeft:"5px"}} onClick={this.onClick}><i className="fas fa-check"></i> {itemTitle}</button>
        } else {
            return <button className="dropdown-item" onClick={this.onClick}>{itemTitle}</button>
        }
    }

    onClick(event) {
        this.props.onClick(this.props.id);
    }
}

export default withTranslation()(FilterItem)